import { t } from 'i18next';

export const FILTER_CACHE_TIME = {
  staleTime: 5 * 60 * 1000,
  cacheTime: 60 * 60 * 1000
};

export const STATUS_OPTIONS = [
  {
    id: 1,
    label: t('new'),
    taskDefinitionKey: 'FlexPortalMatchAcceptRequest',
    flexPortalMatchFlags: null
  },
  {
    id: 2,
    label: t('match'),
    taskDefinitionKey: 'FlexPortalMatchConnectEmployee',
    flexPortalMatchFlags: []
  },
  {
    id: 3,
    label: t('asked'),
    taskDefinitionKey: 'FlexPortalMatchConnectEmployee',
    flexPortalMatchFlags: ['WAITING_FOR_REPLY']
  },
  {
    id: 4,
    label: t('flexMatch.available'),
    taskDefinitionKey: 'FlexPortalMatchConnectEmployee',
    flexPortalMatchFlags: ['ONE_REPLIED_AVAILABLE']
  },
  {
    id: 5,
    label: t('flexMatch.notAvailable'),
    taskDefinitionKey: 'FlexPortalMatchConnectEmployee',
    flexPortalMatchFlags: ['ALL_REPLIED_UNAVAILABLE']
  }
];

export const PREFERENCE_OPTIONS = [
  { label: t('employee'), value: 'EMPLOYEE' },
  { label: t('flexPlanner'), value: 'FLEX_PLANNER' }
];
